import { render, staticRenderFns } from "./VideoSharePage.vue?vue&type=template&id=348beafe&scoped=true&"
import script from "./VideoSharePage.vue?vue&type=script&lang=js&"
export * from "./VideoSharePage.vue?vue&type=script&lang=js&"
import style0 from "./VideoSharePage.vue?vue&type=style&index=0&id=348beafe&scoped=true&lang=css&"
import style1 from "./VideoSharePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348beafe",
  null
  
)

export default component.exports